import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IAddServerCompanyAuthParam, IServerCompanyAuthItem, IServerCompanyAuthParam } from '../../types/crowd-source/company';

const hostUrl = getHostbaseUrl();

/**
 * 众包灵工 - 企业产品管理 - 删除
 */
export async function deleteCompanyAuth(id: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/agent/product/auth/delete`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 众包灵工 - 企业产品管理 - 分页查询
 */
export async function queryServerCompanyAuthPage(param: IServerCompanyAuthParam) {
  let data = [] as IServerCompanyAuthItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IServerCompanyAuthParam;

  try {
    const { code, context, message } = await Http.post<{ data: IServerCompanyAuthItem[]; total: number }>(`${hostUrl}/side/agent/product/auth/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IServerCompanyAuthItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 众包灵工 - 企业产品管理 - 授权、停止授权
 */
export async function changeServerCompanyAuthStatus(id: number, productType: 0 | 1) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/agent/product/auth/added`, {
      id,
      productType, 
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 众包灵工 - 特代授权 - 新增授权
 */
export async function saveProductCompany(params: IAddServerCompanyAuthParam, editType: boolean) {

  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/agent/product/auth/${editType ? 'config' : 'add'}`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 众包、撮合灵工 - 企业产品管理 - 导出
 */

export async function exportCompanyProduct(params: IServerCompanyAuthParam, isCrowd: boolean = false) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/side/agent/product/auth/export/${isCrowd ? 'crowd' : 'match'}`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}